<template>
  <router-view />
</template>

<script setup lang="ts">
import { useQuasar } from 'quasar';
import { initSettings, useSettingsStore } from '@/stores/settings';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';

const $q = useQuasar();
const { locale } = useI18n({ useScope: 'global' });

initSettings(locale.value);
const settings = useSettingsStore();
const auth = useAuthStore();

$q.dark.set(settings.isDarkModeEnabled);

if (settings.getLocale != null) {
  locale.value = settings.getLocale;
}

if (!auth.token) {
  console.log("no token");
}
</script>
